export const profileButtonId = "profile-button";
export const activationCodeId = "code-input";
export const twitterUserId = "1407312164105375747";
export const vimeoChannelUrl = "https://vimeo.com/diagnomatic";
export const dicomHeaderRegex = /(^[a-zA-Z0-9]{4},[a-zA-Z0-9]{4})$/;
